/**
 * Viết hoa chữ đầu tiên
 * @param {*} valueStr
 * @returns
 */
const capitalize = (valueStr) =>
    valueStr.trim().charAt(0).toUpperCase() + valueStr.slice(1);

export { capitalize };
